import React, {useState, useRef} from 'react';
import { Link as RouterLink, useNavigate, useLocation} from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormHelperText,
  Link,
  TextField,
  Typography,
  makeStyles,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  CircularProgress,
  InputAdornment,
  FormControl,
  FormControlLabel
} from '@material-ui/core';
import Page from 'src/components/Page';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash/throttle';
import Firebase from 'src/Firebase';
import DataFetcher from 'src/DataFetcher';
import QuoteStatus from 'src/QuoteStatus';
import HoverMarker from 'src/HoverMarker';
import GoogleMapReact from 'google-map-react';
import JobMasterView from 'src/utils/JobMasterView';
var moment = require('moment');


const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/


function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

const autocompleteService = { current: null };
const geocoder = {current: null};
const directionsService = {current: null};
const directionsDisplay = {current: null};
const bounds = {current: null};



const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  }
}));


const EditQuoteView = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isAuthenticating, setIsAuthenticating] = React.useState(false);

  const {state} = useLocation();
  const loaded = React.useRef(false);
  /*if (typeof window !== 'undefined' && !loaded.current) {
    if (!document.querySelector('#google-maps')) {
      loadScript(
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyAkPLP3zHG-2kctVakLZwdUQHqeLVO0Onw&libraries=places',
        document.querySelector('head'),
        'google-maps',
      );
    }

    loaded.current = true;
  }*/

  function doSubmit(values, locationStart, locationEnd, metadata) {
    console.log(values)
    console.log(Firebase.userInfo)
    setIsAuthenticating(true);
    var v = values 
    v['quoteId'] = state.customer.quoteId
    
    //alert('try it')

    let suc = function () {
      setIsAuthenticating(false)
      //alert('done it')
      navigate(-1)
    }

    let f  = function () {
      setIsAuthenticating(false)
      alert('Error saving changes. Check internet connection and try again.')
    }
    Firebase.editQuoteAuth(v, locationStart, locationEnd, Firebase.uid, suc, f)
  }

  
  React.useEffect(() => {
    
  }, []);

  if (isAuthenticating) {
    return (<Page
      className={classes.root}
      title="Request Quote"
      backgroundColor={classes.root.backgroundColor}
    ><div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}><CircularProgress/></div></Page>)
  }

  return (<JobMasterView editQuoteShipper={true} provideQuote={false} privateQuote={false} publicQuote={false} quoteOffer={false} evaluateBid={false} parentSubmit={(v, ls, le) => doSubmit(v, ls, le)} parentState={state} jobProps={{editable: false, priceEditable: false, showPrices: true, showAssignments: true}} />)

};

/*

        

*/

export default EditQuoteView;
